import { MapType } from '@/types';
import is from './is';

export const hasOtherKeys = (obj: any, key: any) => {
  const keys = Object.keys(obj);
  const otherKeys = keys.filter((requiredkey) => requiredkey !== key);
  return otherKeys.length > 0;
};

export const removeUndefinedKeys = (obj: any) => {
  const keys = Object.keys(obj);
  if (is.empty.array(keys)) return obj;
  let filteredObj: any = {};
  for (let key of keys) {
    if ((obj[key] as any) !== undefined) {
      filteredObj[key] = obj[key];
    }
  }
  return filteredObj;
};
